/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiConfiguration } from '../api-configuration';
import { BaseService } from '../base-service';
import { createOnlineCode, CreateOnlineCode$Params } from '../fn/onlinecode/create-online-code';
import { createOnlineCode1, CreateOnlineCode1$Params } from '../fn/onlinecode/create-online-code-1';
import {
  createOnlineCodeWithParent,
  CreateOnlineCodeWithParent$Params
} from '../fn/onlinecode/create-online-code-with-parent';
import { validateOnlineCode, ValidateOnlineCode$Params } from '../fn/onlinecode/validate-online-code';
import { vehicleForOnlineCode, VehicleForOnlineCode$Params } from '../fn/onlinecode/vehicle-for-online-code';
import { OnlineCode } from '../models/online-code';
import { OnlineCodeValidationResponse } from '../models/online-code-validation-response';
import { StrictHttpResponse } from '../strict-http-response';

/**
 * Store or load vehicle configurations
 */
@Injectable({ providedIn: 'root' })
export class OnlinecodeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createOnlineCode()` */
  static readonly CreateOnlineCodePath =
    '/api/v3/{market}/{subProcess}/{dataVersion}/vehicles/{vehicleId}/onlinecodes/';

  /**
   * Create online-code for the given vehicle-id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOnlineCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  createOnlineCode$Response(
    params: CreateOnlineCode$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<OnlineCode>> {
    return createOnlineCode(this.http, this.rootUrl, params, context);
  }

  /**
   * Create online-code for the given vehicle-id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOnlineCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  createOnlineCode(params: CreateOnlineCode$Params, context?: HttpContext): Observable<OnlineCode> {
    return this.createOnlineCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<OnlineCode>): OnlineCode => r.body)
    );
  }

  /** Path part for operation `createOnlineCode1()` */
  static readonly CreateOnlineCode1Path =
    '/api/v3/{market}/{subProcess}/{dataVersion}/vehicles/{vehicleId}/onlinecodes';

  /**
   * Create online-code for the given vehicle-id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOnlineCode1()` instead.
   *
   * This method doesn't expect any request body.
   */
  createOnlineCode1$Response(
    params: CreateOnlineCode1$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<OnlineCode>> {
    return createOnlineCode1(this.http, this.rootUrl, params, context);
  }

  /**
   * Create online-code for the given vehicle-id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOnlineCode1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  createOnlineCode1(params: CreateOnlineCode1$Params, context?: HttpContext): Observable<OnlineCode> {
    return this.createOnlineCode1$Response(params, context).pipe(
      map((r: StrictHttpResponse<OnlineCode>): OnlineCode => r.body)
    );
  }

  /** Path part for operation `createOnlineCodeWithParent()` */
  static readonly CreateOnlineCodeWithParentPath =
    '/api/v3/{market}/{subProcess}/{dataVersion}/vehicles/{vehicleId}/onlinecodes/{parentVcsId}';

  /**
   * Create online-code for the given vehicle-id with a reference to its parent.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOnlineCodeWithParent()` instead.
   *
   * This method doesn't expect any request body.
   */
  createOnlineCodeWithParent$Response(
    params: CreateOnlineCodeWithParent$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<OnlineCode>> {
    return createOnlineCodeWithParent(this.http, this.rootUrl, params, context);
  }

  /**
   * Create online-code for the given vehicle-id with a reference to its parent.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOnlineCodeWithParent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  createOnlineCodeWithParent(params: CreateOnlineCodeWithParent$Params, context?: HttpContext): Observable<OnlineCode> {
    return this.createOnlineCodeWithParent$Response(params, context).pipe(
      map((r: StrictHttpResponse<OnlineCode>): OnlineCode => r.body)
    );
  }

  /** Path part for operation `vehicleForOnlineCode()` */
  static readonly VehicleForOnlineCodePath =
    '/api/v3/{market}/{subProcess}/{dataVersion}/vehicles/onlinecodes/{onlineCode}';

  /**
   * Resolve the given online-code and retrieve the corresponding data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vehicleForOnlineCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  vehicleForOnlineCode$Response(
    params: VehicleForOnlineCode$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<OnlineCode>> {
    return vehicleForOnlineCode(this.http, this.rootUrl, params, context);
  }

  /**
   * Resolve the given online-code and retrieve the corresponding data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vehicleForOnlineCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vehicleForOnlineCode(params: VehicleForOnlineCode$Params, context?: HttpContext): Observable<OnlineCode> {
    return this.vehicleForOnlineCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<OnlineCode>): OnlineCode => r.body)
    );
  }

  /** Path part for operation `validateOnlineCode()` */
  static readonly ValidateOnlineCodePath = '/api/v3/onlinecodes/{onlinecode}';

  /**
   * Check if the given online-code can be resolved.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `validateOnlineCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  validateOnlineCode$Response(
    params: ValidateOnlineCode$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<OnlineCodeValidationResponse>> {
    return validateOnlineCode(this.http, this.rootUrl, params, context);
  }

  /**
   * Check if the given online-code can be resolved.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `validateOnlineCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  validateOnlineCode(
    params: ValidateOnlineCode$Params,
    context?: HttpContext
  ): Observable<OnlineCodeValidationResponse> {
    return this.validateOnlineCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<OnlineCodeValidationResponse>): OnlineCodeValidationResponse => r.body)
    );
  }
}
